const en = {
  here_today_coupon: "Here’s today’s coupon",
  checkbox: {
    required: "Required",
    optional: "Optional",
  },
  btn: {
    refresh: "Refresh",
    next: "Next",
    back: "Back",
    ok: "OK",
    send_response: "Send response",
    register: "Register",
    delete: "Delete",
    answer: "Answer",
    use: "Use",
    dont_use: "Don’t use",
    close: "Close",
    send_test: "Send test",
  },
  calender: {
    incorrect_date_format: "Incorrect date format",
    cannot_set_date_before_min_year: "Cannot set date before {{minYear}}",
    today: "Today",
  },
  sample_coupon: "Sample coupon",
  use_coupon: "Use coupon",
  terms_and_conditions: "Terms & Conditions",
  only_half_width_numeric_characters: "*only half-width numeric characters",
  only_half_width_alphanumeric_characters: "*only half-width alphanumeric characters",
  enter_a_7_digit_number_without_hyphens: "Enter a 7 digit number without hyphens",
  seven_digit_number_no_hyphens: "7 digit number (no hyphens)",
  this_coupon_has_already_been_used: "This coupon has already been used",
  this_coupon_has_already_expired: "The coupon’s validity period has already passed",
  can_only_be_used_by: "Can only be used by {{name}}",
  recommend_bookmarking_this_page: "*recommend bookmarking this page",
  can_be_used_from: "Can be used from {{date}}",
  this_coupon_can_only_be_used_once: "This coupon can only be used once.",
  cannot_be_used_again_after_displaying: "Cannot be used again after displaying.",
  the_display_time_is_n_minutes_please_show_to_staff_within_n_minutes: 'The display time is {{minutes}} minutes. Please show to staff within {{minutes}} minutes.',
  cannot_be_used_yet: "Cannot be used yet.",
  try_again_after: "Try again after {{date}}.",
  wanna_use_coupon: "Use coupon?",
  remaining_date: '{{date}} remaining',
  current_time: "Current time:",
  valid_until: "Valid until:",
  please_select: "Please select",
  earn_a_coupon: "Earn a coupon",
  we_re_currently_looking_for_participants_for_a_survey_via_phone_in_hopes_to_improve_our_service: "We’re currently looking for participants for a survey via phone in hopes to improve our service.",
  we_will_use_your_feedback_to_continue_making_our_service_better: "We’ll use your feedback to continue making our service better.",
  you_can_get_a_coupon_by_responding_to_our_quiz_or_survey: "You can get a coupon by responding to our quiz or survey!",
  thank_you_for_responding: "Thank you for responding.",
  what_is_the_most_popular_menu_item_at_our_store: "What is the most popular menu item at our store?",
  what_is_the_new_seasonal_menu_for_next_month: "What is the new seasonal menu for next month?",
  answer_text: {
    omelette_rice: "Omelette rice",
    pork_cutlet: "Pork cutlet",
    napolitan: "Napolitan",
    tomato_hamburg: "Tomato hamburg",
    cold_tan_tan_noodles: "Cold tan tan noodles",
    hitsumabushi_eel_rice: "Hitsumabushi eel rice"
  },
  please_select_the_applicable_branches_for_the_survey: "Please select the applicable branches for the Survey",
  no_matching_stores_found: "No matching stores found",
  applicable_branches: "Applicable branches",
  prefecture: {
    no_city_found: 'No matching prefecture found',
    province_select: "Prefecture",
    all_provinces_option: 'All prefectures',
  },
  can_search_using_keywords_like_the_branch_name: "*Can search using keywords like the branch name",
};
export default en;
